import { css } from "styled-components";
import Color from "color";

import { sizeInPxToFontSize, unit } from "./util";

var color = {
  standard: "#100F37",
  background: "#000000",

  primary: "#AF0015",
  primaryText: "#FFF",
  secondary: "#100F37",
  secondaryText: "#FFF",
  success: "#7ED321",
  successText: "#FFF",
  error: "#E74814",
  errorText: "#FFF",

  bullet: "#E74814",
  bulletText: "#FFF"
};

var fontFamilyDefault = ["'Poppins'", "Helvetica", "Verdana", "sans serif"].join(",");
var font = {
  default: function _default() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.3;

    return css(["font:normal ", " / ", " ", ";"], size ? sizeInPxToFontSize(size) : "1em", size && typeof lineHeight === "number" ? sizeInPxToFontSize(size * lineHeight) : unit(lineHeight, "em"), fontFamilyDefault);
  },
  bold: function bold() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.3;

    return css(["font:600 ", " / ", " ", ";"], size ? sizeInPxToFontSize(size) : "1em", size && typeof lineHeight === "number" ? sizeInPxToFontSize(size * lineHeight) : unit(lineHeight, "em"), fontFamilyDefault);
  },
  italic: function italic() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var lineHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1.3;

    return css(["font:normal italic ", " / ", " ", ";"], size ? sizeInPxToFontSize(size) : "1em", size && typeof lineHeight === "number" ? sizeInPxToFontSize(size * lineHeight) : unit(lineHeight, "em"), fontFamilyDefault);
  }
};

export default {
  color: color,
  font: font,
  style: {
    button: css(["", ";background:", ";border:0;border-radius:2px;box-shadow:0 4px 6px 0 rgba(0,0,0,0.24);color:", ";padding:15px 45px;text-align:center;text-transform:lowercase;transition:all 0.25s ease;&:hover,&:active{background-color:", ";}"], font.bold(16, "20px"), function (_ref) {
      var bc = _ref.backgroundColor,
          theme = _ref.theme;
      return bc || theme.color.secondary;
    }, function (_ref2) {
      var c = _ref2.textColor;
      return c || color.secondaryText;
    }, function (_ref3) {
      var bc = _ref3.backgroundColor,
          theme = _ref3.theme;
      return Color(bc || theme.color.secondary).darken(0.15).toString();
    }),
    buttonPrimary: css(["background:", ";color:", ";text-transform:uppercase;&:hover,&:active{background-color:", ";}"], function (_ref4) {
      var bc = _ref4.backgroundColor,
          theme = _ref4.theme;
      return bc || theme.color.primary;
    }, function (_ref5) {
      var c = _ref5.textColor,
          theme = _ref5.theme;
      return c || theme.color.primaryText;
    }, function (_ref6) {
      var bc = _ref6.backgroundColor,
          theme = _ref6.theme;
      return Color(bc || theme.color.primary).darken(0.15).toString();
    }),
    buttonDisabled: css(["cursor:not-allowed;opacity:0.33;pointer-events:none;"]),
    answerAlignment: css(["align-items:center;justify-content:stretch;"])
  }
};
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// /Users/nicolasraynaud/Projets/jeux-mobiles-manitoba/packages/common-react/lib/style/theme.js
// module id = 490
// module chunks = 0